import { put, select, call, takeLatest } from 'redux-saga/effects';
import { LMS_INIT_REQUEST } from '../constants';
import { initLmsSuccessAction, exponeaInitAction } from '../actions';
import * as Selectors from '../selectors';
import { getInitial } from '../../../shared/api/origo';

export function* initLMSRequest() {
  const hasInitialized = yield select(Selectors.hasInitialized);

  if (hasInitialized) {
    return;
  }

  const settings = yield select(Selectors.getSettings);
  const query = yield select(Selectors.getCurrentFilterParams);

  try {
    const result = yield call(getInitial, settings, { ...query });

    yield put(initLmsSuccessAction(result));

    const exponeaData = yield select(Selectors.getExponeaData);
    yield put(exponeaInitAction({}, exponeaData));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to fetch initial departures, call got error ');
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* initLMSRequestSaga() {
  yield takeLatest([LMS_INIT_REQUEST], initLMSRequest);
}
